export default "__VITE_ASSET__7e67b31a__"